import { render } from "./BottomDrawer.vue?vue&type=template&id=07c31356&scoped=true"
import script from "./BottomDrawer.vue?vue&type=script&lang=js"
export * from "./BottomDrawer.vue?vue&type=script&lang=js"

import "./BottomDrawer.vue?vue&type=style&index=0&id=07c31356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c31356"]])

export default __exports__